import { render, staticRenderFns } from "./InformationObligationValidationsModal.vue?vue&type=template&id=9a38c754&"
import script from "./InformationObligationValidationsModal.vue?vue&type=script&lang=js&"
export * from "./InformationObligationValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports